import React from 'react';
import Layout from './src/components/layout/index';
import { AuthProvider, useAuth } from './src/context/AuthContext';
import { Amplify } from 'aws-amplify';
import awsExports from './src/aws-exports';
import PrivateRoute from './src/components/PrivateRoute';
import EmbeddedCasestudyVideoListing from './src/constants/CasestudyVideoListing';
import CasestudyDiy from './src/pages/casestudy';

// Configure Amplify with dynamic redirect URLs based on current origin
// so OAuth works on both localhost and production
const configureAmplify = () => {
  const redirectUrl =
    typeof window !== 'undefined'
      ? `${window.location.origin}/`
      : 'http://localhost:8000/';

  Amplify.configure({
    ...awsExports,
    oauth: {
      ...awsExports.oauth,
      redirectSignIn: redirectUrl,
      redirectSignOut: redirectUrl,
    },
  });
};

configureAmplify();

const loadGoogleTagManager = () => {
  const script = document.createElement("script"); 
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=G-9VE72V0KTW";
  document.head.appendChild(script);

  const inlineScript = document.createElement("script");
  inlineScript.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'G-9VE72V0KTW');
  `;
  document.head.appendChild(inlineScript);
};

export const onClientEntry = () => {
  loadScript();
  loadGoogleTagManager();
};

const loadScript = () => {
  if (!document.getElementById('kpointvideoLoader')) {
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.id = 'kpointvideoLoader';
    script.src =
      'https://assets.kpoint.com/orca/media/embed/videofront-vega.js';

    document.body.appendChild(script);
  }
  if (!document.getElementById('websiteAutomation')) {
    const waScript = document.createElement('script');
    waScript.id = 'websiteAutomation';
    waScript.type = 'text/javascript';
    waScript.async = false;
    waScript.textContent = `
      var w=window;var p = w.location.protocol;if(p.indexOf("http") < 0){p = "http"+":";}var d = document;var f = d.getElementsByTagName('script')[0],s = d.createElement('script');s.type = 'text/javascript'; s.async = false; if (s.readyState){s.onreadystatechange = function(){if (s.readyState=="loaded"||s.readyState == "complete"){s.onreadystatechange = null;try{loadwaprops("3z7909e6cd69a6ad46afcf007fa4b37b27","3z7067b7ecc07bcf4ba84265ee06ba9b80","3zc938608f8fc5bd880b5356fc5df9e22037ce5e57418bbf94646f924996e0f01f","3z587d74df4c8e9b26375dea54bfc7b08c481e16ed3f84b856a54ee357090158dd","0.0");}catch(e){}}};}else {s.onload = function(){try{loadwaprops("3z7909e6cd69a6ad46afcf007fa4b37b27","3z7067b7ecc07bcf4ba84265ee06ba9b80","3zc938608f8fc5bd880b5356fc5df9e22037ce5e57418bbf94646f924996e0f01f","3z587d74df4c8e9b26375dea54bfc7b08c481e16ed3f84b856a54ee357090158dd","0.0");}catch(e){}};};s.src =p+"//ma.zoho.in/hub/js/WebsiteAutomation.js";f.parentNode.insertBefore(s, f);
    `;
    document.body.appendChild(waScript);


    
  }
};

export const wrapRootElement = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
);

const PageWrapper = ({ element, props }) => {
  const { isAuthenticated, role } = useAuth();

  const isPublicVideo = video => {
    return video.visibility === 'public';
  };

  const isMicrosite = props.location.pathname.includes('microsites');

  if (props.location.pathname === '/casestudy/') {
    const searchParams = new URLSearchParams(props.location.search);
    const videoId = searchParams.get('videoId');
    const video = EmbeddedCasestudyVideoListing.find(
      v => v.videoId === videoId
    );

    if (video) {
      if (isPublicVideo(video)) {
        return (
          <Layout>
            <CasestudyDiy {...props}>{element}</CasestudyDiy>
          </Layout>
        );
      } else if (isAuthenticated) {
        return (
          <Layout>
            <CasestudyDiy {...props}>{element}</CasestudyDiy>
          </Layout>
        );
      } else {
        return (
          <Layout>
            <PrivateRoute {...props}>{element}</PrivateRoute>
          </Layout>
        );
      }
    }
  }

  return (
    <Layout isMicrosite={isMicrosite}>
      {isMicrosite ? (
        element
      ) : (
        <PrivateRoute isAuthenticated={isAuthenticated} {...props}>
          {element}
        </PrivateRoute>
      )}
    </Layout>
  );
};

export const wrapPageElement = params => {
  return <PageWrapper {...params} />;
};
